module.exports = __webpack_public_path__ + "assets/img/pic.e024755f.png";